import React from 'react'

export const ENTER = 'Enter'

const FormTextarea = ({
  name = undefined,
  placeholder = undefined,
  disabled = false,
  value = '',
  onBlur = undefined,
  onFocus = undefined,
  onChange,
  preventKeys = [],
  label = undefined,
  id,
  rows = undefined,
  className = undefined,
}) => {
  return (
    <>
    {label && <span className={'formtextarea__label'}>{label}</span>}
    <textarea
      name={name}
      value={value}
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={(e) => {
        if (preventKeys?.includes(ENTER)) {
          e.target.value = e.target.value.replace(/\n/g, ' ')
        }
        onChange(e)
      }}
      onKeyPress={(e) => {
        if (preventKeys?.includes(e.key)) {
          e.preventDefault()
        }
      }}
      className={`formtextarea formfield__input ${className}`}
      disabled={disabled}
      placeholder={placeholder ? placeholder : ''}
      id={id}
      rows={rows} 
    ></textarea>
    </>
  )
}

export default FormTextarea
